<template>
  <v-container fluid class="monitor px-12 pt-5 pb-6">
    <v-row justify="center" align="end" class="monitor pa-3">
      <v-col
        cols="12"
        sm="6"
        class="display-1 white--text text-center text-sm-left"
      >
        TABLERO DINÁMICO
        <span class="font-weight-light pl-3">
          {{
            branchOffices[$route.params.branchOffice]
              ? `SUCURSAL ${branchOffices[
                  $route.params.branchOffice
                ].toUpperCase()}`
              : "OPERACIÓN GLOBAL"
          }}
        </span>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="text-center text-sm-right display-1 white--text"
      >
        <v-row justify="center" align="end">
          <v-col
            cols="12"
            sm="12"
            class="text-center text-sm-right display-1 white--text pb-0"
          >
            {{ day }} -
            <span class="font-weight-light">{{ date }}</span>
            -
            {{ hour }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-container fluid class="full-height dark white--text ma-0 pa-0">
      <v-row class="monitor full-height">
        <v-col cols="12" sm="12" lg="6">
          <v-row>
            <v-col cols="12" sm="12" lg="4">
              <prosic-products-chart></prosic-products-chart>
            </v-col>
            <v-col cols="12" sm="12" lg="4">
              <prosic-products-service></prosic-products-service>
            </v-col>
            <v-col cols="12" sm="12" lg="4">
              <prosic-products-demand></prosic-products-demand>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" lg="8">
              <prosic-services-workshop></prosic-services-workshop>
            </v-col>
            <v-col cols="12" sm="12" lg="4">
              <prosic-services-total></prosic-services-total>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" lg="8">
              <prosic-services-field></prosic-services-field>
            </v-col>
            <v-col cols="12" sm="12" lg="4">
              <prosic-services-time></prosic-services-time>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" lg="6">
          <v-row>
            <v-col cols="12">
              <prosic-people-ranking
                v-show="!showGlobal && isVenue"
                :venue="$route.params.branchOffice"
                :intervalChangeSeconds="15"
              ></prosic-people-ranking>
              <prosic-people-ranking
                v-show="showGlobal || !isVenue"
                :intervalChangeSeconds="15"
              ></prosic-people-ranking>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import moment from "moment";
import PeopleRanking from "@/components/dynamic-board/PeopleRanking.vue";
import ProductsChart from "@/components/dynamic-board/ProductsChart.vue";
import ProductsService from "@/components/dynamic-board/ProductsService.vue";
import ProductsDemand from "@/components/dynamic-board/ProductsDemand.vue";
import ServicesWorkshop from "@/components/dynamic-board/ServicesWorkshop.vue";
import ServicesField from "@/components/dynamic-board/ServicesField.vue";
import ServicesTotal from "@/components/dynamic-board/ServicesTotal.vue";
import ServicesTime from "@/components/dynamic-board/ServicesTime.vue";
import { firestore } from "@/config/firebase";
moment.locale("ES");
export default {
  data() {
    return {
      branch: {
        text: "Global",
        value: "global"
      },
      branchOffices: [],
      dropDownBackground: "#282b34",
      day: "",
      date: "",
      hour: "",
      showGlobal: this.$route.params.branchOffice ? false : true
    };
  },
  async mounted() {
    this.branchOffices = (await firestore("dynamic-board")
      .doc("commun")
      .get()).data().productVenues;
    this.day = moment(new Date()).format("dddd");
    this.day = this.day.charAt(0).toUpperCase() + this.day.slice(1);
    this.date = moment(new Date()).format("DD MMMM YYYY");
    this.clockUpdate();
  },
  computed: {
    isVenue() {
      if (this.$route.params.branchOffice) return true;
      return false;
    }
  },
  components: {
    ProsicPeopleRanking: PeopleRanking,
    ProsicProductsChart: ProductsChart,
    ProsicProductsService: ProductsService,
    ProsicProductsDemand: ProductsDemand,
    ProsicServicesWorkshop: ServicesWorkshop,
    ProsicServicesField: ServicesField,
    ProsicServicesTotal: ServicesTotal,
    ProsicServicesTime: ServicesTime
  },
  methods: {
    clockUpdate() {
      setInterval(
        function() {
          this.hour = moment(new Date()).format("hh:mm");
        }.bind(this),
        1000
      );
    }
  }
};
</script>
<style lang="css">
.overflow-select-text.theme--light.v-select .v-select__selections {
  color: rgba(0, 0, 0, 0.87);
  font-size: 11px !important;
}
.white-overflow.theme--light.v-select .v-select__selections {
  color: rgba(255, 255, 255, 0.87) !important;
  font-size: 12px !important;
}
.highcharts-legend {
  display: none;
}
.highcharts-background {
  height: 50px;
}
.white-overflow .theme--light.v-icon {
  color: rgba(255, 255, 255, 0.54);
}
tspan {
  font-family: "Oswald", sans-serif !important;
  font-weight: 400;
}
</style>
<style lang="css" scoped>
.monitor {
  background-color: #282b34;
}
.full-height {
  height: 100%;
}
</style>
